<template>
  <div id="matching-table-container">
    <el-table id="matching-table" :data="caregiversList" :row-class-name="gray"  @row-click="rowClick">
      <el-table-column prop="caregiverId" label="เลขผู้ดูแล" width="87"/>
      <el-table-column prop="type" label="ประเภท" width="73"/>
      <el-table-column prop="name" label="ชื่อผู้ดูแล" width="185"/>
      <el-table-column prop="label" label="" width="45">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" content="" placement="right-start">
            <div style="font-family: 'Sukhumvit'; line-height: 22px;" slot="content">
              <div style="font-family: 'Sukhumvit-Bold'; margin-bottom: 4px;">
                {{scope.row.reasonTitle}}
              </div>
              {{scope.row.reasonDetail}}
            </div>
            <img class="img-24" v-if="scope.row.reasonTitle === 'สาเหตุที่ผู้ดูแลออกจากเคส'" src="https://storage.healthathome.in.th/f86f95e7-e813-4a8c-bd5e-c53fc1dac304.svg" />
            <img class="img-24" v-if="scope.row.reasonTitle === 'สาเหตุที่ลูกค้าไม่ใช้บริการคนนี้ต่อ'" src="https://storage.healthathome.in.th/ab2609eb-8d6b-459b-966b-7dd7bf91bd34.svg" />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="เบอร์โทร" width="125"/>
      <el-table-column prop="address" label="สถานที่อยู่" width="120"/>
      <el-table-column prop="rating" label="เรทติ้ง" width="70"/>
      <el-table-column prop="cases" label="เคสทั้งหมด" width="100"/>
      <el-table-column prop="avgShifts" label="เวร/เคส" width="77"/>
      <el-table-column prop="shifts" label="เวรกับเคสนี้" width="110"/>
      <el-table-column prop="status" label="สถานะการแมทช์" >
        <template slot-scope="scope">
          <el-row>
            <el-col>
              <MatchingLineActionPanel v-if="canSendCgProfile" :itemData="scope.row" :itemIndex="scope.$index"
                :disabled="scope.row.customerRejected"
                :fake="fake"
                :feedback="scope.row.feedback"
                @acceptButtonClick="approveCaregiver"
                @rejectButtonClick="rejectCaregiver"
                @sendProfileButtonClick="sendCaregiverProfile"
                @resendProfileButtonClick="resendCaregiverProfile"/>
              <MatchingDirectActionPanel v-else :itemData="scope.row" :itemIndex="scope.$index" :fake="fake"
                @acceptButtonClick="approveCaregiver"
                @rejectButtonClick="rejectCaregiver"/>
            </el-col>
            
          </el-row>
        </template>
      </el-table-column>
       <el-table-column prop="timestamp" label="เวลา" width="300"/>
    </el-table>

    <!-- Match Before Send Profile Dialog -->
    <el-dialog :visible.sync="control.sendCaregiverProfileDialog" :showClose="true" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">คุณต้องการส่งโปรไฟล์ผู้ดูแลให้ลูกค้า ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleMatchBeforeSendProfile(false)">ไม่ส่งโปรไฟล์</el-button>
        <el-button type="primary" @click="handleMatchBeforeSendProfile(true)" class="edit">ส่งโปรไฟล์</el-button>
      </span>
    </el-dialog>

    <!-- reject Caregiver Dialog -->
    <el-dialog :visible.sync="control.rejectCaregiverDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">คุณต้องการปฏิเสธผู้ดูแลกับงานนี้ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleRejectCaregiver(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleRejectCaregiver(true)" class="edit">ปฏิเสธ</el-button>
      </span>
    </el-dialog>

    <!-- resend Caregiver Profile Dialog -->
    <el-dialog :visible.sync="control.resendCaregiverProfileDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">คุณส่งโปรไฟล์ให้ลูกค้าแล้ว คุณต้องการส่งโปรไฟล์ผู้ดูแลไปยังลูกค้าอีกรอบ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleResendCaregiverProfileDialog(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleResendCaregiverProfileDialog(true)" class="edit">ส่งโปรไฟล์</el-button>
      </span>
    </el-dialog>

    <!-- Match Caregiver Dialog -->
    <el-dialog :visible.sync="control.approveCaregiverDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div class="header-18" style="margin-left: 17px;">คุณต้องการแมทช์ผู้ดูแลกับงานนี้ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleApproveCaregiverDialog(false)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleApproveCaregiverDialog(true)" class="edit">แมทช์</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .img-24 {
    margin-left: 0px;
    padding-left: 0px;
    padding-bottom: 1px;
  }

  .el-button {
    font-family: 'Sukhumvit-Bold';
    font-size: 18px;
    padding: 10px 16px;
  }

  .el-dialog__footer {
    padding-bottom: 24px;
  }

  #matching-table-container {
    .header-18 {
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;
      color: #434B61;
    }

    .cancel-button {
      min-width: 80.92px;
      border: 1.5px solid #409EFF;
      transition: .2s;
      span {
        color: #409EFF;
        transition: .2s;
      }
      &:hover {
        background: #409EFF;
        transition: .2s;
        span {
          color: #FFFFFF;
          transition: .2s;
        }
      }
    }
  }
</style>

<style lang="scss">

  .el-table td.el-table_1_column_10 {
    padding-top: 15px;
    padding-bottom: 1px;
  }

  .el-table td, .el-table th {
    padding: 25px 0;
  }

  .date {
    font-size: 11px;
    font-weight: 500;
    color: #c0c4cc;
  }

  .gray {
    color: #c0c4cc;
  }

  .sent-profile-button, .sent-profile-button:focus {
    font-family: 'Sukhumvit-Bold';
    font-size: 11px !important;
    font-weight: 500;
    color: rgb(255, 255, 255);
    border: 1.5px solid rgb(50, 50, 50);
    background: rgba(50, 50, 50, 1) !important;
    height: 36.4px;
    width: 70px;
    padding: 10px 4px !important;
  }

  .sent-profile-button:hover {
    color: #000;
    border: 1.5px solid rgb(50, 50, 50);
    background: rgba(50, 50, 50, 0) !important;
  }

  .reject-button {
    font-family: 'Sukhumvit-Bold';
    font-size: 11px !important;
    font-weight: 500;
    background: rgba(64, 158, 255, 0) !important;
    height: 36.4px;
    width: 70px;
    padding: 10px 4px !important;
  }

  .consider-button:disabled, .consider-button:hover {
    font-family: 'Sukhumvit-Bold';
    font-size: 11px !important;
    font-weight: 500;
    color: #FFF !important;
    background: #c0c4cc !important;
    height: 36.4px;
    width: 70px;
    padding: 10px 4px !important;
  }
</style>

<script>
import MatchingLineActionPanel from '@/components/matching/MatchingLineActionPanel'
import MatchingDirectActionPanel from '@/components/matching/MatchingDirectActionPanel'


export default {
  name: 'MatchingTable',
  components: {
    MatchingLineActionPanel,
    MatchingDirectActionPanel,
  },
  props: {
    caregiversList: {
      type: Array,
      required: true,
    },
    canSendCgProfile: {
      type: Boolean,
      required: true,
    },
    fake: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      control: {
        approveCaregiverDialog: false,
        rejectCaregiverDialog: false,
        sendCaregiverProfileDialog: false,
        resendCaregiverProfileDialog: false,
      },
      rowSelected: null,
    }
  },
  methods: {
    rowClick (rowItem, column, event) {
      if (column.property !== 'status') {
        let routeData = this.$router.resolve({ name: 'CaregiverDetail', params: { id: rowItem.caregiverId }, query: { tab: 'caregiverinfoTab' } })
        window.open(routeData.href, '_blank')
      }
    },
    async approveCaregiver (index, row) {
      this.control.approveCaregiverDialog = true
      this.rowSelected = row
    },
    rejectCaregiver (index, row) {
      this.control.rejectCaregiverDialog = true
      this.rowSelected = row
    },
    sendCaregiverProfile (index, row) {
      this.control.sendCaregiverProfileDialog = true
      this.rowSelected = row
    },
    resendCaregiverProfile (index, row) {
      this.control.resendCaregiverProfileDialog = true
      this.rowSelected = row
    },
    handleMatchBeforeSendProfile (status) {
      if (status) {
        this.$emit('sendCaregiverProfile', this.rowSelected.caregiverId)
      } else {
        this.$emit('approveCaregiver', this.rowSelected.caregiverId)
      }
      this.control.sendCaregiverProfileDialog = false
    },
    handleRejectCaregiver (status) {
      if (status) {
        this.$emit('rejectCaregiver', this.rowSelected.caregiverId)
      }
      this.control.rejectCaregiverDialog = false
    },
    handleResendCaregiverProfileDialog (status) {
      if (status) {
        this.$emit('sendCaregiverProfile', this.rowSelected.caregiverId)
      }
      this.control.resendCaregiverProfileDialog = false
    },
    handleApproveCaregiverDialog (status) {
      if (status) {
        this.$emit('approveCaregiver', this.rowSelected.caregiverId)
      }
      this.control.approveCaregiverDialog = false
    },
  },
}
</script>
